<app-nav-pages></app-nav-pages>

<main>
  <section class="hero-section d-flex align-items-center position-relative">
    <div class="hero-background"></div>
    <div class="hero-content-wrapper">
      <div class="hero-text-content">
        <h1 class="hero-name">LUCKY R. ERHERHA</h1>
        <p class="hero-title">Founder & CEO, Zumera Property</p>
        <a routerLink="/who-we-are/leadership/ceo" class="hero-read-more-btn">
          <span>Read More</span>
          <span
            ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="16"
            viewBox="0 0 13 16"
            fill="none"
            >
            <path
              d="M1.00006 14.2611L9.95122 0.999263L1.00006 14.2611ZM9.95122 0.999263L11.5677 9.32914L9.95122 0.999263ZM9.95122 0.999263L1.62134 2.61577L9.95122 0.999263Z"
              fill="white"
              />
              <path
                d="M1.00006 14.2611L9.95122 0.999263M9.95122 0.999263L11.5677 9.32914M9.95122 0.999263L1.62134 2.61577"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg></span>
            </a>
          </div>
        </div>
      </section>
      <section class="container">
        <div class="text-center py-5 mb-5">
          <h2>EXECUTIVE LEADERSHIP</h2>
        </div>

        <article class="d-flex flex-column gap-5 flex-wrap">
          @for (leader of leaders; track leader; let i = $index) {
            <div
              class="d-flex gap-2 staff_card f-c"
              [ngClass]="{ 'left-align': i % 2 === 0, 'right-align': i % 2 !== 0 }"
              >
              <div class="staff_imgs">
                <img src="{{ leader.img }}" class="img-fluid" />
              </div>
              <div class="staff_info p-3 wo-100">
                <div class="staff_title">
                  <h3 class="leaders">{{ leader.name }}</h3>
                  <p class="leaders_title">{{ leader.title }}</p>
                </div>
                <div class="staff_desc">
                  <p>
                    {{
                    leader.isShown ? leader.desc : (leader.desc | slice : 0 : 200)
                    }}
                  </p>
                </div>
                <!-- Show "Read More" button if description length exceeds 100 characters -->
                @if (leader.desc.length > 200) {
                  <button (click)="toggleRead(leader)">
                    {{ leader.isShown ? "Read Less" : "Read More..." }}
                  </button>
                }
              </div>
            </div>
          }
        </article>
      </section>
    </main>

    <div class="my-5 d-flex flex-column">
      <p class="quote_3_p text-center">
        NEXT <span class="rdj_bold">&#8594;</span>
      </p>
      <h3 class="mb-3 text-center rdj_bold">ZUMERA HOSPITALITY</h3>
      <a routerLink="/hospitality" class="know-more-btn align-self-center"
        >KNOW MORE</a
        >
      </div>

      <app-footer class="w-100 d-none d-sm-block"></app-footer>
      <app-footer-sm class="w-100 d-sm-none"></app-footer-sm>
